import { render } from "./EllipsisCell.vue?vue&type=template&id=41362898&scoped=true"
import script from "./EllipsisCell.vue?vue&type=script&lang=js"
export * from "./EllipsisCell.vue?vue&type=script&lang=js"

import "./EllipsisCell.vue?vue&type=style&index=0&id=41362898&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41362898"]])

export default __exports__